import { Vehicle } from "./Vehicle";
import { Bicycle } from "./Bicycle";
import { Wall } from "./Wall";

export class Metrics {
  // metrics
  bearingAngle: number[]; // 1st: front, 2nd: middle, 3rd: back
  gamma: number = 0;
  looming: number;
  PPET: number;
  wall: Wall;
  bicycleVisible: boolean = false;
  latDist: number[];

  dt = 0.01;
  constructor(wall?: Wall, dt?: number) {
    if (wall !== undefined) this.wall = wall;
    if (dt !== undefined) this.dt = dt;
  }
  update(vehicle: Vehicle, bicycle: Bicycle) {
    // calculate bearing angle
    this.updateBearingAngle(vehicle, bicycle);
    this.updateLooming(vehicle, bicycle);
    this.updatePPET(vehicle, bicycle);
    this.updateBicycleVisibility(vehicle, bicycle);
    this.updateLatDist(vehicle, bicycle);
  }

  updateBearingAngle(vehicle: Vehicle, bicycle: Bicycle) {
    let bearingAngle = [];

    let carPoint = [
      vehicle.position[0] - vehicle.origin[0] + vehicle.driverPosition[0],
      vehicle.position[1] - vehicle.origin[1] + vehicle.driverPosition[1]
    ];

    let bicyclePoint = [];

    bicyclePoint[0] = bicycle.position[0] + bicycle.origin[1] - bicycle.length; // front
    bicyclePoint[1] = bicycle.position[0]; // to origin
    bicyclePoint[2] = bicycle.position[0] + bicycle.origin[1]; // to back
    let i = 0;
    bicyclePoint.forEach(element => {
      if (carPoint[0] < 0) {
        bearingAngle[i] = Math.atan2(element - carPoint[0], -carPoint[1]);
      } else {
        bearingAngle[i] = NaN;
      }
      i++;
    });
    this.bearingAngle = bearingAngle;
  }
  getBearingAngle() {
    return this.bearingAngle;
  }

  updateLooming(vehicle: Vehicle, bicycle: Bicycle) {
    let currGamma = -Math.atan(vehicle.driverPosition[2] / vehicle.position[1]);
    this.looming = (currGamma - this.gamma) / (this.dt * currGamma);
    this.gamma = currGamma;
  }
  getLooming() {
    return this.looming;
  }
  updatePPET(vehicle: Vehicle, bicycle: Bicycle) {
    let distBikeRear2CarLeft =
      bicycle.position[0] +
      bicycle.length -
      bicycle.origin[1] -
      vehicle.position[0] +
      vehicle.origin[0];
    let timeBikeRear2CarLeft = distBikeRear2CarLeft / -bicycle.speed;

    let distCarFront2BikeLeft =
      bicycle.position[1] -
      bicycle.origin[0] -
      (vehicle.position[1] + vehicle.length - vehicle.origin[1]);
    let timeCarFront2BikeLeft = distCarFront2BikeLeft / vehicle.speed;

    let distBikeFront2CarRight =
      bicycle.position[0] -
      bicycle.origin[1] -
      (vehicle.position[0] + (-vehicle.origin[0] + vehicle.width));
    let timeBikeFront2CarRight = distBikeFront2CarRight / -bicycle.speed;

    let distCarRear2BikeRight =
      bicycle.position[1] -
      bicycle.origin[0] +
      bicycle.width -
      (vehicle.position[1] - vehicle.origin[1]);
    let timeCarRear2BikeRight = distCarRear2BikeRight / vehicle.speed;

    let PPETCarAfterBike = timeCarFront2BikeLeft - timeBikeRear2CarLeft;
    let PPETBikeAfterCar = timeBikeFront2CarRight - timeCarRear2BikeRight;

    let PPET = 0;
    if (PPETBikeAfterCar > 0) PPET = -PPETBikeAfterCar;
    if (PPETCarAfterBike > 0) PPET = PPETCarAfterBike;

    this.PPET = PPET;
  }
  getPPET() {
    return this.PPET;
  }
  updateLatDist(vehicle: Vehicle, bicycle: Bicycle) {
    let distBikeRear2CarLeft =
      bicycle.position[0] +
      bicycle.length -
      bicycle.origin[1] -
      vehicle.position[0] +
      vehicle.origin[0];

    let distBikeFront2CarRight =
      bicycle.position[0] -
      bicycle.origin[1] -
      (vehicle.position[0] + (-vehicle.origin[0] + vehicle.width));

    this.latDist = [distBikeFront2CarRight, distBikeRear2CarLeft];
  }
  getLatDist() {
    return this.latDist;
  }
  updateBicycleVisibility(vehicle: Vehicle, bicycle: Bicycle) {
    //  get intersection point
    //  get the driver position over time
    let driverPosition = [
      vehicle.position[0] - vehicle.origin[0] + vehicle.driverPosition[0],
      vehicle.position[1] - vehicle.origin[1] + vehicle.driverPosition[1]
    ];
    // calculate angle to bicycle front wheel and intersection point
    let bikeFrontPos = [
      bicycle.position[0] + bicycle.origin[1] - bicycle.length,
      bicycle.position[1]
    ];
    let angleToBike = -Math.atan(
      (bikeFrontPos[0] - driverPosition[0]) /
        (bikeFrontPos[1] - driverPosition[1])
    );
    // calculate angle to walls points and intersection point
    let angleToWall = -Math.atan(
      (this.wall.point1[0] - driverPosition[0]) /
        (this.wall.point1[1] - driverPosition[1])
    );
    //  compare the angles, if angle to bicycle is smaller than the others, then
    // the bicycle is visible

    let visible1 = Math.abs(angleToBike) <= Math.abs(angleToWall);
    //  check if the bicycle is closer to the car than the wall edge
    let visible2 =
      (bikeFrontPos[0] - driverPosition[0]) ** 2 +
        (bikeFrontPos[1] - driverPosition[1]) ** 2 <
      (this.wall.point1[0] - driverPosition[0]) ** 2 +
        (this.wall.point1[1] - driverPosition[1]) ** 2;
    if (visible1 || visible2) {
      this.bicycleVisible = true;
    } else {
      this.bicycleVisible = false;
    }
  }
  isBicycleVisible() {
    return this.bicycleVisible;
  }
  reset(vehicle: Vehicle, bicycle: Bicycle, wall?: Wall, dt?: number) {
    this.gamma = 0;
    if (wall !== undefined) this.wall = wall;
    if (dt !== undefined) this.dt = dt;
    this.update(vehicle, bicycle);
  }
}
